export default function EllipsisLoader() {
    return (
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    )
}